<template>
    <div class="dashboard-container">
        <!-- Mobile Overlay -->
        <div v-if="sidebarCollapsed && isMobile" class="mobile-overlay" @click="closeSidebar"></div>
        
        <!-- Sidebar -->
        <aside class="sidebar" :class="{ 'collapsed': sidebarCollapsed, 'mobile-open': isMobile && sidebarCollapsed }">
            <div class="sidebar-header">
                <img src="../assets/utility/logo/Logo LR Pro Marketing - circular - sin slogan.png" alt="LR Pro Marketing" class="logo">
                <h3 v-if="!sidebarCollapsed || isMobile">Dashboard</h3>
                <button class="sidebar-toggle" @click="toggleSidebar">
                    <i class="fa-solid fa-bars"></i>
                </button>
            </div>

            <nav class="sidebar-nav">
                <router-link to="/dashboard" class="nav-item" active-class="active" @click="closeSidebarOnMobile">
                    <i class="fa-solid fa-home"></i>
                    <span v-if="!sidebarCollapsed || isMobile">Inicio</span>
                </router-link>
                <router-link to="/dashboard/portfolio" class="nav-item" active-class="active" @click="closeSidebarOnMobile">
                    <i class="fa-solid fa-briefcase"></i>
                    <span v-if="!sidebarCollapsed || isMobile">Portafolio</span>
                </router-link>
                <router-link to="/dashboard/contacts" class="nav-item" active-class="active" @click="closeSidebarOnMobile">
                    <i class="fa-solid fa-envelope"></i>
                    <span v-if="!sidebarCollapsed || isMobile">Contactos</span>
                </router-link>
                <router-link to="/dashboard/settings" class="nav-item" active-class="active" @click="closeSidebarOnMobile">
                    <i class="fa-solid fa-cog"></i>
                    <span v-if="!sidebarCollapsed || isMobile">Configuración</span>
                </router-link>
            </nav>

            <div class="sidebar-footer">
                <button class="logout-btn" @click="handleLogout">
                    <i class="fa-solid fa-sign-out-alt"></i>
                    <span v-if="!sidebarCollapsed || isMobile">Cerrar Sesión</span>
                </button>
            </div>
        </aside>

        <!-- Main Content -->
        <main class="main-content">
            <!-- Header -->
            <header class="dashboard-header">
                <div class="header-left">
                    <button v-if="isMobile" class="mobile-menu-btn" @click="toggleSidebar">
                        <i class="fa-solid fa-bars"></i>
                    </button>
                    <div class="header-text">
                        <h1>{{ pageTitle }}</h1>
                        <p>{{ pageDescription }}</p>
                    </div>
                </div>
                <div class="header-right">
                    <div class="user-info">
                        <span class="welcome-text">Bienvenido, {{ user.username }}</span>
                        <button class="theme-toggle" @click="toggleTheme">
                            <i :class="isDarkTheme ? 'fa-solid fa-sun' : 'fa-solid fa-moon'"></i>
                        </button>
                    </div>
                </div>
            </header>

            <!-- Content Area -->
            <div class="content-area">
                <router-view></router-view>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    name: 'DashboardPage',
    data() {
        return {
            sidebarCollapsed: false,
            isDarkTheme: false,
            isMobile: false,
            user: {
                username: 'Admin'
            }
        }
    },
    computed: {
        pageTitle() {
            const route = this.$route.name;
            const titles = {
                'Dashboard': 'Panel Principal',
                'PortfolioManagement': 'Gestión de Portafolio',
                'ContactManagement': 'Gestión de Contactos',
                'Settings': 'Configuración'
            };
            return titles[route] || 'Dashboard';
        },
        pageDescription() {
            const route = this.$route.name;
            const descriptions = {
                'Dashboard': 'Resumen general y estadísticas',
                'PortfolioManagement': 'Gestiona los proyectos de tu portafolio',
                'ContactManagement': 'Administra mensajes de contacto y suscripciones',
                'Settings': 'Configura las preferencias del sistema'
            };
            return descriptions[route] || 'Panel de administración';
        }
    },
    methods: {
        toggleSidebar() {
            this.sidebarCollapsed = !this.sidebarCollapsed;
        },
        closeSidebar() {
            if (this.isMobile) {
                this.sidebarCollapsed = false;
            }
        },
        closeSidebarOnMobile() {
            if (this.isMobile) {
                this.sidebarCollapsed = false;
            }
        },
        toggleTheme() {
            this.isDarkTheme = !this.isDarkTheme;
            document.body.classList.toggle('dark-theme', this.isDarkTheme);
        },
        handleLogout() {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            localStorage.removeItem('rememberMe');
            this.$router.push('/login');
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        }
    },
    mounted() {
        // Verificar autenticación
        const token = localStorage.getItem('authToken');
        if (!token) {
            this.$router.push('/login');
            return;
        }

        // Cargar datos del usuario
        const userData = localStorage.getItem('user');
        if (userData) {
            this.user = JSON.parse(userData);
        }

        // Verificar tema oscuro
        this.isDarkTheme = document.body.classList.contains('dark-theme');
        
        // Detectar dispositivo móvil
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile);
    }
}
</script>

<style lang="scss" scoped>

.actions-cell {
    display: flex;
    gap: 10px;
    align-items: center;

    button.action-btn {
        background: none;
        padding: 10px;
        border: none;
    }
}
.dashboard-container {
    display: flex;
    min-height: 100vh;
    font-family: 'Poppins', sans-serif;
    position: relative;

    // Mobile overlay
    .mobile-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
        display: none;
        
        @media (max-width: 768px) {
            display: block;
        }
    }

    .sidebar {
        width: 280px;
        height: 100vh;
        position: sticky;
        top: 0;
        left: 0;
        background: #1f2122;
        color: white;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        z-index: 1000;

        &.collapsed {
            width: fit-content;

            .sidebar-header {
                h3 {
                    display: none;
                }
            }

            .sidebar-nav {
                .nav-item {
                    span {
                        display: none;
                    }
                }
            }

            .sidebar-footer {
                .logout-btn {
                    span {
                        display: none;
                    }
                }
            }
        }

        // Mobile styles
        @media (max-width: 768px) {
            position: fixed;
            left: -280px;
            top: 0;
            height: 100vh;
            width: 280px;
            z-index: 1001;

            &.mobile-open {
                left: 0;
            }

            .sidebar-header {
                h3 {
                    display: block !important;
                }
            }

            .sidebar-nav {
                .nav-item {
                    span {
                        display: block !important;
                    }
                }
            }

            .sidebar-footer {
                .logout-btn {
                    span {
                        display: block !important;
                    }
                }
            }
        }



        .sidebar-header {
            padding: 20px;
            border-bottom: 1px solid #333;
            display: flex;
            align-items: center;
            gap: 15px;

            .logo {
                width: 40px;
                height: 40px;
            }

            h3 {
                margin: 0;
                font-size: 18px;
                font-weight: 600;
            }

            .sidebar-toggle {
                margin-left: auto;
                background: none;
                border: none;
                color: #ccc;
                cursor: pointer;
                font-size: 16px;

                &:hover {
                    color: #f08908;
                }
            }
        }

        .sidebar-nav {
            flex: 1;
            padding: 20px 0;

            .nav-item {
                display: flex;
                align-items: center;
                gap: 15px;
                padding: 15px 20px;
                color: #ccc;
                text-decoration: none;
                transition: all 0.3s ease;
                border-left: 3px solid transparent;

                &:hover {
                    background: #2b2a2a;
                    color: #f08908;
                }

                &.active {
                    background: #2b2a2a;
                    color: #f08908;
                    border-left-color: #f08908;
                }

                i {
                    font-size: 18px;
                    width: 20px;
                    text-align: center;
                }

                span {
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }

        .sidebar-footer {
            padding: 20px;
            border-top: 1px solid #333;

            .logout-btn {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 15px;
                background: none;
                border: none;
                color: #ccc;
                cursor: pointer;
                padding: 12px;
                border-radius: 8px;
                transition: all 0.3s ease;

                &:hover {
                    background: #2b2a2a;
                    color: #ff6b6b;
                }

                i {
                    font-size: 16px;
                }

                span {
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
    }

    .main-content {
        flex: 1;
        background: #f8f9fa;
        display: flex;
        flex-direction: column;

        @media (max-width: 768px) {
            margin-left: 0;
        }

        .dashboard-header {
            background: white;
            padding: 20px 30px;
            border-bottom: 1px solid #e1e5e9;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-left {
                display: flex;
                align-items: center;
                gap: 20px;

                .mobile-menu-btn {
                    display: none;
                    background: none;
                    border: none;
                    color: #666;
                    font-size: 20px;
                    cursor: pointer;
                    padding: 8px;
                    border-radius: 8px;
                    transition: all 0.3s ease;

                    &:hover {
                        background: #f0f0f0;
                        color: #1f8cc6;
                    }

                    @media (max-width: 768px) {
                        display: block;
                    }
                }

                .header-text {
                    h1 {
                        margin: 0 0 5px 0;
                        font-size: 24px;
                        font-weight: 600;
                        color: #333;

                        @media (max-width: 768px) {
                            font-size: 20px;
                        }

                        @media (max-width: 480px) {
                            font-size: 18px;
                        }
                    }

                    p {
                        margin: 0;
                        color: #666;
                        font-size: 14px;

                        @media (max-width: 480px) {
                            font-size: 12px;
                        }
                    }
                }
            }

            .header-right {
                .user-info {
                    display: flex;
                    align-items: center;
                    gap: 20px;

                    .welcome-text {
                        color: #666;
                        font-size: 14px;

                        @media (max-width: 768px) {
                            display: none;
                        }
                    }

                    .theme-toggle {
                        background: none;
                        border: none;
                        color: #666;
                        cursor: pointer;
                        font-size: 18px;
                        padding: 8px;
                        border-radius: 50%;
                        transition: all 0.3s ease;

                        &:hover {
                            background: #f0f0f0;
                            color: #1f8cc6;
                        }
                    }
                }
            }

            @media (max-width: 768px) {
                padding: 15px 20px;
            }

            @media (max-width: 480px) {
                padding: 12px 15px;
            }
        }

        .content-area {
            flex: 1;
            padding: 30px;
            overflow-y: auto;

            @media (max-width: 768px) {
                padding: 20px;
            }

            @media (max-width: 480px) {
                padding: 15px;
            }
        }
    }
}

// Dark theme
body.dark-theme .dashboard-container {
    .main-content {
        background: #1f2122;

        .dashboard-header {
            background: #2b2a2a;
            border-bottom-color: #444;

            .header-left {
                .mobile-menu-btn {
                    color: #ccc;

                    &:hover {
                        background: #444;
                        color: #f08908;
                    }
                }

                .header-text {
                    h1 {
                        color: #ffffff;
                    }

                    p {
                        color: #ccc;
                    }
                }
            }

            .header-right {
                .user-info {
                    .welcome-text {
                        color: #ccc;
                    }

                    .theme-toggle {
                        color: #ccc;

                        &:hover {
                            background: #444;
                            color: #f08908;
                        }
                    }
                }
            }
        }
    }
}

// Responsive improvements
@media (max-width: 1024px) {
    .dashboard-container {
        .sidebar {
            width: 240px;
        }
    }
}

@media (max-width: 768px) {
    .dashboard-container {
        .sidebar {
            position: fixed;
            left: -280px;
            top: 0;
            height: 100vh;
            width: 280px;
            z-index: 1001;
            transition: left 0.3s ease;

            &.mobile-open {
                left: 0;
            }
        }

        .main-content {
            margin-left: 0;
        }
    }
}

@media (max-width: 480px) {
    .dashboard-container {
        .sidebar {
            width: 260px;
        }

        .main-content {
            .dashboard-header {
                .header-left {
                    gap: 15px;
                }
            }
        }
    }
}

@media (max-width: 360px) {
    .dashboard-container {
        .sidebar {
            width: 240px;
        }
    }
}
</style> 